import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import Image from "gatsby-image";
import Box from "common/components/Box";
import Text from "common/components/Text";
import Heading from "common/components/Heading";
import Button from "common/components/Button";
import Input from "common/components/Input";
import FeatureBlock from "common/components/FeatureBlock";
import ParticlesComponent from "../particles";
import Container from "common/components/UI/Container";
import { Icon } from "react-icons-kit";
import { ic_arrow_forward } from "react-icons-kit/md/ic_arrow_forward";
import { BannerSquareShape, BannerCircleShape } from "../app.style";
import {
	DiscountWrapper,
	DiscountLabel,
	ButtonWrapper,
	EmailInputWrapper,
} from "./banner.style";

const DomainSection = ({
	SectionWrapper,
	row,
	col,
	title,
	description,
	button,
	image,
	imageArea,
	btnStyleTwo,
	discountAmount,
	discountText,
}) => {
	const Data = useStaticQuery(graphql`
		query {
			appScreenshot: file(relativePath: { eq: "image/app/mobile.png" }) {
				childImageSharp {
					fluid(quality: 100) {
						...GatsbyImageSharpFluid
					}
				}
			}
		}
	`);

	return (
		<Box {...SectionWrapper}>
			<ParticlesComponent />
			<BannerSquareShape />
			<BannerCircleShape />
			<Container>
				<Box {...row}>
					<Box {...col}>
						<Box>
							<DiscountWrapper>
								<DiscountLabel>
									<Text {...discountAmount} className='discountAmount' />
									<Text {...discountText} />
								</DiscountLabel>
							</DiscountWrapper>
						</Box>
						<FeatureBlock
							title={<Heading {...title} />}
							description={<Text {...description} />}
						/>
						<EmailInputWrapper>
							<Input
								inputType='email'
								placeholder='Enter Email Address'
								iconPosition='left'
								aria-label='email'
							/>
						</EmailInputWrapper>
						<ButtonWrapper>
							<a
								href='https://linktr.ee/islam360'
								rel='noreferrer'
								target='_blank'>
								<Button title='DOWNLOAD NOW' {...button} />
							</a>
							<a
								href='https://www.youtube.com/channel/UCoTPuvcNYCha3xQCJfZxDcQ'
								rel='noreferrer'
								target='_blank'>
								<Button
									{...button}
									{...btnStyleTwo}
									title='WATCH DEMOS'
									icon={<Icon icon={ic_arrow_forward} />}
									className='withoutBg'
								/>
							</a>
						</ButtonWrapper>
					</Box>
					<Box {...col} {...imageArea}>
						<Box {...image}>
							<Image
								fluid={
									(Data.appScreenshot !== null) | undefined
										? Data.appScreenshot.childImageSharp.fluid
										: {}
								}
								alt='Domain Image'
							/>
						</Box>
					</Box>
				</Box>
			</Container>
		</Box>
	);
};

DomainSection.propTypes = {
	SectionWrapper: PropTypes.object,
	row: PropTypes.object,
	col: PropTypes.object,
	title: PropTypes.object,
	description: PropTypes.object,
	button: PropTypes.object,
	btnStyleTwo: PropTypes.object,
	discountAmount: PropTypes.object,
	discountText: PropTypes.object,
	textArea: PropTypes.object,
};

DomainSection.defaultProps = {
	SectionWrapper: {
		as: "section",
		pt: "80px",
		pb: "80px",
		overflow: "hidden",
	},
	row: {
		flexBox: true,
		flexWrap: "wrap",
		ml: "-15px",
		mr: "-15px",
		alignItems: "center",
	},
	imageAreaRow: {
		flexDirection: "row-reverse",
	},
	col: {
		pr: "15px",
		pl: "15px",
		width: ["100%", "100%", "50%", "44%", "44%"],
		mt: "-80px",
	},
	imageArea: {
		width: ["0%", "0%", "43%", "35%", "40%"],
		ml: "auto",
	},
	title: {
		content: "World's Number One Quran Search Engine",
		fontSize: ["26px", "30px", "30px", "48px", "60px"],
		fontWeight: "300",
		color: "#0f2137",
		letterSpacing: "-0.01px",
		mb: "20px",
	},
	description: {
		content:
			"We are focusing to deliver the true picture of Islam with the help of technology because technology is the ultimate reality. ITM holds the honor of creating the world’s first application (for Computer and Mobile) on The Holy Quran and Hadees.",
		fontSize: "16px",
		color: "#343d48",
		lineHeight: "33px",
		mb: "10px",
	},
	button: {
		type: "button",
		minWidth: "156px",
		fontSize: "14px",
		fontWeight: "500",
		color: "#fff",
		borderRadius: "4px",
		pl: "22px",
		pr: "22px",
		colors: "primaryWithBg",
	},
	image: {
		ml: "auto",
		mt: "70px",
	},
	btnStyleTwo: {
		minWidth: "156px",
		ml: "15px",
		bg: "#fff",
		color: "rgb(63, 154, 2)",
	},
	textArea: {
		width: ["100%", "100%", "50%", "55%", "55%"],
	},
	discountAmount: {
		content: "update",
		fontSize: "14px",
		fontWeight: "600",
		color: "#fff",
		mb: 0,
		as: "span",
		mr: "0.4em",
		bg: "rgb(63, 154, 2)",
	},
	discountText: {
		content: "Version 4.0.15 has just released .",
		fontSize: "13px",
		fontWeight: "400",
		color: "#0f2137",
		mb: 0,
		as: "span",
		ml: "10px",
	},
};

export default DomainSection;
